import React from "react";
import { ReportDetail } from "../types/types";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { formatDate } from "../utils/utils";

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

type ReportDetailProps = {
    data: ReportDetail
};
const DetailReport = ( props: ReportDetailProps) => {
    return (
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
              Reported Created @ {formatDate(new Date(props.data.checkRunAt))}
            </Typography>

            <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>Reported From: </Typography><Typography variant="h6" sx={{ fontSize: 18 }} component="p">{props.data.reporterMonitorLabel}</Typography>
            <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>Verified From From: </Typography><Typography variant="h6" sx={{ fontSize: 18 }} component="p">{props.data.verifierMonitorLabel}</Typography>
            <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>Error Message: </Typography><Typography variant="h6" sx={{ fontSize: 18 }} component="p"> {props.data.errorMessage}</Typography>
          </CardContent>
        </Card>
      );
};

export default DetailReport;
